import {NginxLocationConfiguration} from "./NginxLocationConfiguration";

export class NginxLocationConf {
    id: number;
    domainName: string;
    path: string;
    description: string | null;
    proxyPassType: string;
    proxyPass?: string | null;
    proxyHeaderHost?: string | null;
    staticFile: string | null;
    staticPath: string | null;
    configurations: NginxLocationConfiguration[];
    sequence: number;
    createTime: Date;
    updateTime: Date;
}

export enum ProxyPassType {
    APP_KEY,
    FRONTEND,
    RETURN,
    REWRITE,
    NONE
}

export namespace ProxyPassTypeExt {

    export function values(): ProxyPassType[] {
        return Object.values(ProxyPassType)
            .filter(value => typeof value === 'number') as ProxyPassType[];
    }

    export function fromString(type: string): ProxyPassType {
        return ProxyPassType[type as keyof typeof ProxyPassType] as ProxyPassType;
    }

    export function getDescription(type: ProxyPassType): string {
        switch (type) {
            case ProxyPassType.APP_KEY:
                return "服务AppKey";
            case ProxyPassType.FRONTEND:
                return "前端";
            case ProxyPassType.RETURN:
                return "自定义返回";
            case ProxyPassType.REWRITE:
                return "URL重写";
            case ProxyPassType.NONE:
                return "无";
        }
    }
}